/* Zoss — página de produto: troca de variante, galeria e adicionar à sacola. */
(function () {
  'use strict';

  var root = document.querySelector('[data-zs-product]');
  if (!root) return;

  var PRODUCT = window.ZOSS_PRODUCT || null;
  if (!PRODUCT) return;

  var DATA = window.ZOSS_DATA || {};
  var money = window.ZossCart ? window.ZossCart.money : function (cents) {
    return new Intl.NumberFormat(DATA.locale || 'pt-BR', {
      style: 'currency',
      currency: DATA.currency || 'BRL'
    }).format((cents || 0) / 100);
  };
  var INSTALLMENTS = window.ZossCart ? window.ZossCart.installments : (parseInt(DATA.installments, 10) || 6);

  var current = PRODUCT.variants.filter(function (v) { return String(v.id) === String(PRODUCT.selected_id); })[0]
    || PRODUCT.variants.filter(function (v) { return v.available; })[0]
    || PRODUCT.variants[0];

  var priceNow = root.querySelector('[data-zs-price]');
  var priceWas = root.querySelector('[data-zs-compare]');
  var pricePct = root.querySelector('[data-zs-pct]');
  var instEl = root.querySelector('[data-zs-inst]');
  var buy = root.querySelector('[data-zs-buy]');
  var barBtn = root.querySelector('[data-zs-buy-bar]');
  var qtyView = root.querySelector('[data-zs-qty-view]');
  var stock = root.querySelector('[data-zs-stock]');
  var idInput = root.querySelector('[data-zs-variant-id]');
  var qtyInput = root.querySelector('[data-zs-qty]');
  var mainImg = root.querySelector('[data-zs-main-image]');
  var swatchName = root.querySelector('[data-zs-variant-name]');
  var pairWrap = root.querySelector('[data-zs-pair-progress]');
  var pairFill = root.querySelector('[data-zs-pair-fill]');
  var pairMsg = root.querySelector('[data-zs-pair-msg]');
  var productForm = root.querySelector('[data-zs-product-form]');
  var buyLabel = root.querySelector('[data-zs-buy-label]');
  var barLabel = root.querySelector('[data-zs-buy-bar-label]');
  var buyNote = root.querySelector('[data-zs-buy-note]');
  var buyStatus = root.querySelector('[data-zs-buy-status]');

  // A imagem principal tem srcset com descritores w. Quando ele existe, o
  // navegador escolhe a foto pelo srcset e ignora o src por completo — trocar
  // so o src nao muda nada na tela. Por isso os dois sao reescritos juntos,
  // derivando os candidatos pela troca do parametro width= da URL do CDN.
  function srcsetFor(url) {
    return [420, 800, 1200].map(function (w) {
      return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function setMainImage(url, alt) {
    if (!mainImg || !url) return;
    if (/width=\d+/.test(url)) {
      mainImg.srcset = srcsetFor(url);
      mainImg.src = url.replace(/width=\d+/, 'width=800');
    } else {
      mainImg.srcset = '';
      mainImg.src = url;
    }
    if (alt) mainImg.alt = alt;
  }

  // Aquece o cache antes do clique. Sem isso a troca espera o download da foto
  // grande, o que na tela aparece como um atraso de uns 300ms depois do clique.
  var warmed = {};
  function warmImage(url) {
    if (!url || warmed[url]) return;
    warmed[url] = true;
    var img = new Image();
    if (/width=\d+/.test(url)) {
      // sizes antes de srcset: sem os dois o navegador escolhe um candidato
      // diferente do que a imagem principal vai pedir, e o cache nao serve.
      img.sizes = mainImg && mainImg.sizes ? mainImg.sizes : '100vw';
      img.srcset = srcsetFor(url);
      img.src = url.replace(/width=\d+/, 'width=800');
    } else {
      img.src = url;
    }
  }

  function warmOnIntent(el, url) {
    ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
      el.addEventListener(ev, function () { warmImage(url); }, { passive: true, once: true });
    });
  }

  function currentQty() {
    return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
  }

  function promoQty() {
    return window.ZossCart && typeof window.ZossCart.promoQty === 'function'
      ? window.ZossCart.promoQty()
      : 0;
  }

  function ctaCopy() {
    var eligible = promoQty();
    if (eligible % 2 === 1) {
      return {
        label: 'Adicionar ao carrinho',
        note: '2º passo: adicione este modelo para completar sua dupla.'
      };
    }
    if (eligible > 0) {
      return {
        label: 'Adicionar ao carrinho',
        note: 'Monte outra dupla: adicione este modelo e depois escolha o próximo.'
      };
    }
    return {
      label: 'Adicionar ao carrinho',
      note: '1º passo: coloque este modelo na sacola. Depois escolha o segundo.'
    };
  }

  // Barra fixa e botão principal: espelham etapa da oferta, quantidade e preço.
  function updateBar() {
    var copy = ctaCopy();
    if (qtyView) qtyView.textContent = currentQty();
    if (buy) buy.disabled = !current.available;
    if (buyLabel) buyLabel.textContent = current.available ? copy.label : 'Esgotado';
    if (buyNote) buyNote.textContent = current.available ? copy.note : 'Escolha outra opção disponível.';
    if (barBtn) {
      barBtn.disabled = !current.available;
      if (barLabel) {
        barLabel.textContent = current.available
          ? copy.label + ' · ' + money(current.price * currentQty())
          : 'Esgotado';
      }
    }
  }

  function paint() {
    priceNow.textContent = money(current.price);
    if (priceWas) {
      priceWas.hidden = !(current.compare_at_price && current.compare_at_price > current.price);
      priceWas.textContent = money(current.compare_at_price);
    }
    if (pricePct) {
      var off = current.compare_at_price && current.compare_at_price > current.price
        ? Math.round((1 - current.price / current.compare_at_price) * 100)
        : 0;
      pricePct.hidden = off <= 0;
      pricePct.textContent = '−' + off + '%';
    }
    if (instEl) instEl.textContent = 'ou ' + INSTALLMENTS + 'x de ' + money(current.price / INSTALLMENTS) + ' sem juros, ou à vista no Pix';
    if (swatchName) swatchName.textContent = current.title;
    if (idInput) idInput.value = current.id;

    root.querySelectorAll('[data-variant]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.variant === String(current.id)));
    });

    if (current.image) {
      setMainImage(current.image, PRODUCT.title + ' ' + current.title);
    }

    if (stock) {
      var limit = parseInt(DATA.low_stock_threshold, 10) || 0;
      var low = current.available && current.managed && limit > 0 && current.qty > 0 && current.qty <= limit;
      stock.classList.toggle('is-low', low);
      stock.textContent = !current.available
        ? 'Sem estoque nesta cor'
        : low
          ? (current.qty === 1 ? 'Resta 1 unidade nesta cor' : 'Restam ' + current.qty + ' unidades nesta cor')
          : 'Pronta entrega';
    }
    updateBar();
    paintThumbs();

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState({}, '', url);
    }
  }

  // Progresso do "leve 2" dentro do bloco de promoção, com o carrinho real.
  function paintPair() {
    updateBar();
    if (!pairWrap || !window.ZossCart) return;
    var cart = window.ZossCart.cart || {};
    var eligible = typeof window.ZossCart.promoQty === 'function' ? window.ZossCart.promoQty() : 0;
    var odd = eligible % 2 === 1;
    pairWrap.hidden = eligible === 0;
    if (eligible === 0) return;
    if (pairFill) pairFill.style.width = odd ? '50%' : '100%';
    if (pairMsg) {
      pairMsg.textContent = odd
        ? 'Falta 1 óculos para o segundo sair grátis.'
        : (cart.total_discount > 0 ? 'O desconto do par entrou na sacola.' : 'Dupla montada. Confira o desconto na sacola.');
    }
  }

  root.querySelectorAll('[data-variant]').forEach(function (b) {
    var bv = PRODUCT.variants.filter(function (x) { return String(x.id) === b.dataset.variant; })[0];
    if (bv && bv.image) warmOnIntent(b, bv.image);
    b.addEventListener('click', function () {
      if (!bv) return;
      current = bv;
      paint();
    });
  });

  var variantSelect = root.querySelector('[data-zs-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var v = PRODUCT.variants.filter(function (x) { return String(x.id) === variantSelect.value; })[0];
      if (!v) return;
      current = v;
      paint();
    });
  }

  // Fileira de miniaturas filtrada por cor. So liga quando a section marca o
  // root com data-zs-group-thumbs; sem isso nada muda nas outras PDPs.
  var groupThumbs = root.hasAttribute('data-zs-group-thumbs');
  var allThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-zs-thumb]'));

  function paintThumbs() {
    if (!groupThumbs || !allThumbs.length) return;
    var mine = allThumbs.filter(function (t) {
      var v = t.getAttribute('data-zs-thumb-variant');
      return !v || v === 'shared' || String(v) === String(current.id);
    });
    // Nenhuma foto amarrada nessa cor: mostra a fileira inteira em vez de esvaziar.
    var show = mine.length ? mine : allThumbs;
    allThumbs.forEach(function (t) { t.hidden = show.indexOf(t) === -1; });
    // A capa da variante e sempre a primeira do grupo, entao ela fica marcada.
    show.forEach(function (t, i) { t.setAttribute('aria-pressed', String(i === 0)); });
  }

  root.querySelectorAll('[data-zs-thumb]').forEach(function (t) {
    warmOnIntent(t, t.dataset.zsThumb);
    t.addEventListener('click', function () {
      if (!mainImg) return;
      setMainImage(t.dataset.zsThumb, t.dataset.zsThumbAlt || PRODUCT.title);
      root.querySelectorAll('[data-zs-thumb]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === t)); });
    });
  });

  if (qtyInput) {
    root.querySelectorAll('[data-zs-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = currentQty() + parseInt(b.dataset.zsQtyStep, 10);
        qtyInput.value = Math.max(1, next);
        updateBar();
      });
    });
    qtyInput.addEventListener('input', function () {
      if (parseInt(qtyInput.value, 10) > 0) updateBar();
    });
    qtyInput.addEventListener('change', function () {
      qtyInput.value = currentQty();
      updateBar();
    });
  }

  function addCurrent(btn) {
    if (!current.available || !window.ZossCart) return;
    var qty = currentQty();
    [buy, barBtn].forEach(function (button) {
      if (!button) return;
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    });
    if (buyStatus) buyStatus.textContent = 'Adicionando à sacola…';

    window.ZossCart.add(current.id, qty, { title: PRODUCT.title, variant: current.title, price: current.price })
      .then(function () {
        if (buyStatus) buyStatus.textContent = 'Adicionado à sacola.';
        [buy, barBtn].forEach(function (button) {
          if (!button) return;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        });
        paint();
      })
      .catch(function (e) {
        var message = e.message || 'Não deu para adicionar. Tente novamente.';
        if (buyStatus) buyStatus.textContent = message;
        window.ZossCart.toast(message);
        [buy, barBtn].forEach(function (button) {
          if (!button) return;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        });
        paint();
      });
  }

  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      // Sem o controlador personalizado, deixa o formulário nativo seguir para
      // /cart/add. Assim um bloqueador, app ou erro externo não mata a compra.
      if (!window.ZossCart) return;
      event.preventDefault();
      addCurrent(event.submitter || buy);
    });
  }

  document.addEventListener('zoss:cart_updated', paintPair);

  if (window.ZossCart) {
    window.ZossCart.track('view_item', {
      items: [{ item_id: current.id, item_name: PRODUCT.title, item_variant: current.title, item_brand: 'Zoss', price: current.price / 100, quantity: 1 }],
      value: current.price / 100,
      content_name: PRODUCT.title
    });
  }

  // Depois que a pagina assenta, adianta as primeiras fotos da galeria e as
  // fotos das cores. Pulado em conexao lenta ou com economia de dados ligada,
  // para nao gastar franquia de quem nem vai abrir a galeria.
  function warmIdle() {
    var c = navigator.connection || {};
    if (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) return;
    root.querySelectorAll('[data-zs-thumb]').forEach(function (t, i) {
      if (i < 4) warmImage(t.dataset.zsThumb);
    });
    PRODUCT.variants.forEach(function (v) { if (v.image) warmImage(v.image); });
  }
  if (window.requestIdleCallback) requestIdleCallback(warmIdle, { timeout: 3000 });
  else window.addEventListener('load', function () { setTimeout(warmIdle, 1200); });

  paint();
  paintPair();
})();

